import { useCallback, useState } from 'react';
import isEqual from 'react-fast-compare';
import { SortingState, Updater } from '@tanstack/react-table';

import { TableSorting } from './types';

export function useDefaultSortingState(initialSortBy: SortingState = []): TableSorting {
  const [sortOrder, setSortOrder] = useState<SortingState>(initialSortBy);
  const onSortingChange = useCallback((tableSortBy: SortingState | Updater<SortingState>) => {
    setSortOrder((prevOrder) => {
      const newSortOrder = typeof tableSortBy === 'function' ? tableSortBy(prevOrder) : tableSortBy;
      return isEqual(newSortOrder, prevOrder) ? prevOrder : newSortOrder;
    });
  }, []);
  return { onSortingChange, sorting: sortOrder };
}
